<template>
  <div class="auth-container">
    <div class="auth-card">
      <div class="auth-header">
        <img src="/lamusica-logo.svg" alt="LaMusica" class="auth-logo">
        <p>Sign in to your account</p>
      </div>
      
      <form @submit.prevent="handleLogin" class="auth-form">
        <div class="form-group">
          <label for="email">Email</label>
          <input
            id="email"
            v-model="email"
            type="email"
            placeholder="you@example.com"
            required
            autofocus
          />
        </div>
        
        <div class="form-group">
          <label for="password">Password</label>
          <input
            id="password"
            v-model="password"
            type="password"
            placeholder="••••••••"
            required
          />
        </div>
        
        <div class="forgot-password">
          <router-link to="/forgot-password">Forgot password?</router-link>
        </div>
        
        <div v-if="error" class="error-message">
          {{ error }}
        </div>
        
        <button type="submit" class="btn-primary" :disabled="loading">
          {{ loading ? 'Signing in...' : 'Sign In' }}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginView',
  data() {
    return {
      email: '',
      password: '',
      error: null,
      loading: false
    }
  },
  methods: {
    async handleLogin() {
      this.error = null
      this.loading = true
      
      try {
        const user = await this.$store.dispatch('auth/login', {
          email: this.email,
          password: this.password
        })
        
        if (user.mustChangePassword) {
          this.$router.push('/change-password')
        } else {
          this.$router.push('/stations')
        }
      } catch (err) {
        this.error = err.message
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.auth-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--gray-100);
  padding: 20px;
}

.auth-card {
  background: var(--white);
  border-radius: 8px;
  box-shadow: var(--shadow-xl);
  padding: 40px;
  width: 100%;
  max-width: 400px;
}

.auth-header {
  text-align: center;
  margin-bottom: 32px;
}

.auth-logo {
  height: 40px;
  width: auto;
  margin-bottom: 12px;
}

.auth-header p {
  font-size: 14px;
  color: var(--gray-500);
  margin: 0;
}

.auth-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group label {
  font-size: 14px;
  font-weight: 500;
  color: var(--gray-700);
}

.form-group input {
  padding: 10px 12px;
  border: 1px solid var(--gray-200);
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.form-group input:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px rgba(51, 147, 255, 0.1);
}

.error-message {
  background: #fef2f2;
  color: var(--error);
  padding: 10px 12px;
  border-radius: 6px;
  font-size: 14px;
}

.btn-primary {
  padding: 12px;
  background: var(--accent);
  color: var(--white);
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s;
}

.btn-primary:hover:not(:disabled) {
  background: var(--accent-hover);
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.forgot-password {
  text-align: right;
  margin-top: -12px;
}

.forgot-password a {
  font-size: 13px;
  color: var(--accent);
  text-decoration: none;
}

.forgot-password a:hover {
  text-decoration: underline;
}
</style>
